import React, { useState } from "react";
import emailjs from "emailjs-com";
import { useNavigate } from "react-router-dom";

const EnquiryForm = ({ discription, code, caseNumber }) => {
  const [formData, setFormData] = useState({
    name: "",
    phone: "",
    email: "",
    companyname: "",
    message: "",
  });

  const [loading, setLoading] = useState(false);
    const navigate = useNavigate();

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    setLoading(true);

    // include extra props along with formData
    const payload = {
      ...formData,
      discription,
      code,
      caseNumber,
    };

    emailjs
      .send(
        "service_072v2ro",   // ✅ your service ID
        "template_kipna77",  // ✅ your template ID
        payload,
        "CIZ12kLcaltC4-oBD"  // ✅ your public key
      )
        .then(
        () => {
          alert(
        "✅ Thank You! 🎉\n" +
        "Your enquiry has been submitted successfully.\n" +
        "Our team will review your request and get back to you shortly with the details you need.\n" +
        "✅ What happens next:\n" +
        " • You’ll receive a confirmation email soon.\n" +
        " • One of our team members will reach out within 24–48 hours.\n" +
        "We appreciate your interest and look forward to assisting you!\n" +
        "👉 Return to Products"
      );
          setFormData({ name: "", phone: "", email: "", companyname: "", message: "" });
          setLoading(false);
          navigate("/products"); // 🔗 redirect
        },
        () => {
          alert("❌ Failed to send enquiry. Try again.");
          setLoading(false);
        }
      );
  };

  return (
    <div className="enquiry-form p-4 border rounded shadow-md max-w-md mx-auto">
      <h1 className="text-xl font-bold mb-3">Enquiry Form</h1> 
      <p className="d-none"><strong>Code:</strong> {code}</p>
      <p className="d-none" ><strong>Case Number:</strong> {caseNumber}</p>
      <p className="d-none"><strong>Discription:</strong> {discription}</p>     

      <form onSubmit={handleSubmit}>
        <div className="row">
        <div className="col-md-6 mb-20">
          <label className="block mb-1">Enter Name *</label>
          <input
            type="text"
            name="name"
            className="form-control w-full border p-2 rounded"
            placeholder="Enter Name"
            value={formData.name}
            onChange={handleChange}
            required
          />
        </div>

        <div className="col-md-6 mb-20">
          <label className="block mb-1">Enter Mobile Number *</label>
          <input
            type="tel"
            name="phone"
            className="form-control w-full border p-2 rounded"
            placeholder="Enter Mobile Number"
            value={formData.phone}
            onChange={handleChange}
            required
          />
        </div>

        <div className="col-md-6 mb-20">
          <label className="block mb-1">Enter Email *</label>
          <input
            type="email"
            name="email"
            className="form-control w-full border p-2 rounded"
            placeholder="Enter Email"
            value={formData.email}
            onChange={handleChange}
            required
          />
        </div>

        <div className="col-md-6 mb-20">
          <label className="block mb-1">Enter CompanyName *</label>
          <input
            type="text"
            name="companyname"
            className="form-control w-full border p-2 rounded"
            placeholder="Enter CompanyName"
            value={formData.companyname}
            onChange={handleChange}
            required
          />
        </div>

        <div className="col-12 mb-20">
          <label className="block mb-1">Message</label>
          <textarea
            name="message"
            className="form-control w-full border p-2 rounded"
            placeholder="Message"
            value={formData.message}
            onChange={handleChange}
          />
        </div>

        <div>
          <button
            type="submit"
            disabled={loading}
            className="btn-fll rounded "
          >
            {loading ? "Sending..." : "Enquiry"}
          </button>
        </div>
        </div>
      </form>
    </div>
  );
};

export default EnquiryForm;
